export default "__VITE_ASSET__B0nT67A$__"